import { AppCard, AppCardContent, AppCardMedia, AppCardTitle } from '@app/components/base/app-card';
import { EnrichedCompositionListItemDto } from '@app/modules/compose/composition.types';
import { FragmentCardCreator } from '@app/modules/fragments/screens/list/fragment-card/base/FragmentCardCreator';
import { FragmentCardRelativeTime } from '@app/modules/fragments/screens/list/fragment-card/base/FragmentCardRelativeTime';
import { fragmentGridCardContentSx } from '@app/modules/fragments/screens/list/fragment-card/base/styles';
import { FRAGMENT_CARD_PADDING_X } from '@app/modules/fragments/screens/list/fragment-card/constants';
import { Box } from '@mui/material';
import { composeRouteGenerator } from '../../../routing/compose-route-generator';
import { CompositionCardMedia } from './CompositionCardMedia';

const footerSx = {
  px: FRAGMENT_CARD_PADDING_X,
  pb: 1.5,
  pt: 0,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  columnGap: 0.5,
  rowGap: 0.25,
} as const;

/**
 * List card for a composition: navigates to composition detail (Editions).
 */
export function CompositionCard({ composition }: { composition: EnrichedCompositionListItemDto }) {
  return (
    <AppCard
      to={{
        pathname: composeRouteGenerator.view(composition.id),
        state: { composition },
      }}
      media={
        <AppCardMedia>
          <CompositionCardMedia composition={composition} />
        </AppCardMedia>
      }
      footer={
        <Box sx={footerSx}>
          <FragmentCardCreator creator={composition.creator} />
          <FragmentCardRelativeTime createdAt={composition.createdAt} />
        </Box>
      }
    >
      <AppCardContent sx={fragmentGridCardContentSx}>
        <AppCardTitle title={composition.name} />
      </AppCardContent>
    </AppCard>
  );
}
